/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */
import React, { useState, useEffect } from "react"
import { Container, Row, Nav, SSRProvider } from "react-bootstrap"
import CustomNavbar from "./navBar"
import SiteFooter from "./Footer/Footer"
import Menu from "gatsby-plugin-drupal-menus"
import Search from "./Search/Search"
import ScrollToTop from "./scrollToTop";

const Layout = ({ children, pageInfo, dataHome, className }) => (
  <SSRProvider>
    <div className={className}>
      <Row className="g-0">
        <Header />
      </Row>
      <main className="main" role="main">{children}</main>
      <SiteFooter />
    </div>
    <ScrollToTop />
  </SSRProvider>
)



function Header(pageInfo) {
  const [isFixed, setFixed] = useState(false),
    [scrollPosition, setScrollPosition] = useState(true)

  useEffect(() => {
    let scrollPos = 0
    const handleScroll = () => {
      //const currentScrollY = window.scrollY - incompatible with ie11
      const currentScrollY = window.pageYOffset

      if ((document.body.getBoundingClientRect()).top > scrollPos) {
        if(scrollPosition) setScrollPosition(true)
      } else {
        if(scrollPosition) setScrollPosition(false)
      }

      scrollPos = (document.body.getBoundingClientRect()).top

      if (currentScrollY >= 20) {
        setFixed(true)
      } else {
        setFixed(false)
      }

      if(currentScrollY === 0) {
        if(scrollPosition) setScrollPosition(true)
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [setFixed, setScrollPosition])

  return (
    <div className={`header ${isFixed ? "isFixed" : ""}`}>
      <Nav className={`nav--secondary ${scrollPosition ? "js-directionUp" : "js-directionDown"}`}>
        <Container fluid>
          <Row className="justify-content-end">
            <a className="nav-link RT-placeholder rTapNumber433518" href="tel:02076001660">
              020 7600 1660
            </a>
            <Menu menuName={`secondary-header-menu`} />
          </Row>
        </Container>
      </Nav>
      <CustomNavbar pageInfo={pageInfo} />
      <Search />
    </div>
  )
}

//

export default Layout
